export default __webpack_public_path__ + "static/media/justice-icon.73a2644e.png";